/**
 * Indicador de carga con texto opcional.
 *
 * El texto no es decorativo: un spinner sin explicación genera la pregunta
 * "¿está fallando?", y en una pantalla de carga de verdad esa duda hace que la
 * gente recargue la página y pierda lo que estaba escribiendo.
 */
export function Cargador({ texto }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16" role="status">
      <span
        className="size-8 animate-spin rounded-full border-2 border-ink-200 border-t-brand-600"
        aria-hidden="true"
      />
      {texto ? <p className="text-sm text-ink-500">{texto}</p> : null}
      <span className="sr-only">{texto ?? 'Cargando'}</span>
    </div>
  );
}
